var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_224_143)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0003 2.6862C20.454 2.6862 24.0772 6.30934 24.0772 10.7628C24.0772 15.2165 20.454 18.8399 16.0003 18.8399C11.5466 18.8399 7.92345 15.2165 7.92345 10.7628C7.92345 6.30934 11.5466 2.6862 16.0003 2.6862ZM16.0014 25.8164C21.0756 25.8164 25.5777 27.4979 28.417 30.1035L26.5205 32C24.1728 29.9021 20.2912 28.5026 16.0014 28.5026C11.7115 28.5026 7.83263 29.9021 5.48221 32L3.58307 30.1035C6.42238 27.5006 10.9271 25.8164 16.0014 25.8164ZM16.0003 0C21.9446 0 26.7634 4.81877 26.7634 10.7628C26.7634 16.7071 21.9446 21.5261 16.0003 21.5261C10.056 21.5261 5.23726 16.7071 5.23726 10.7628C5.23726 4.81877 10.056 0 16.0003 0Z",
    fill: "#ACCAF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_224_143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.2327be42efa5b75111d095d52e213e83.svg";
export { ForwardRef as ReactComponent };